(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inline-booking"] && !Shopify.designMode) return;
  try {
    function updateIframeHeight() {
    const iframe = document.querySelector('.inline-booking-iframe');
    if (!iframe) return;

    // Calculate available viewport height
    const viewportHeight = window.innerHeight;

    // Set height based on screen size
    if (window.innerWidth <= 640) {
      // Tablet: use 80% of viewport
      iframe.style.height = '1400px';
    }
    else {
      // Desktop: use 80% of viewport
      iframe.style.height = '1000px';
    }
  }

  // Update on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateIframeHeight);
  } else {
    updateIframeHeight();
  }

  // Update on resize
  window.addEventListener('resize', updateIframeHeight);
  } catch(e) { console.error(e); }
})();

})();
